import React from 'react';
import Logo from '../../assets/images/Logoimage.png';
import Bg from '../../assets/images/bg.png';
import Login from './Login';
import { Route, Redirect, Switch } from 'react-router-dom';
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(()=> ({
    logoSize: { width: '150px', margin: "10px" },
    login: { width: "360px", paddingTop: "25%", position:"relative", minHeight:"95vh" },
    padTop: { padding: "0 40px", paddingTop: "40%", color: "#fff", lineHeight:'1.5' },
    clrWhite: { color: "#fff !important" },
    fntSze20: { fontSize: "20px !important" },
    fntSze19: { fontSize: "19px !important" },
    footerWrap:{ maxWidth: "360px",textAlign: "center",position: "sticky",bottom: 0,background: "#fff",padding: "10px 0"}
}));

const PublicPage = (props) => {
    const classes = useStyles();
    return(
        <>
            <div>
                <GridContainer style={{ backgroundColor: "#fff", height:'100%' }}>
                    <GridItem lg={4} md={4}
                        style={{
                            backgroundImage: `url(${Bg})`,
                            backgroundRepeat: "repeat-y",
                        }}>
                        <div className={classes.padTop}>
                            <h2 className={classes.clrWhite+ " " + classes.fntSze20}>A pilot study of the MyHOPE™ for Multiple Myeloma Platform.</h2> <br/>
                            <div style={{ backgroundColor: "#fff", height: "1.5px", width: "50px" }}></div><br/><br/>
                            <p className={classes.clrWhite + " " + classes.fntSze19} style={{marginBottom:40}}>
                            The study is designed to better understand whether a digital tool, in addition to a care plan, can help people living with multiple myeloma.</p>
                            <p className={classes.clrWhite + " " + classes.fntSze19}>Thank you for your participation.</p>
                        </div>
                    </GridItem>
                    <GridItem lg={2} md={2} style={{height:'100vh'}}>
                        <div>
                            <br /><br />
                            <img alt="" src={Logo} className={classes.logoSize} />
                        </div>
                    </GridItem>
                    <GridItem lg={6} md={6} style={{height:'100%'}}>
                        <div className={classes.login}>
                            <Switch>
                                <Route path={`${props.match.url}/Login`} component={Login} />
                                <Redirect to={`${props.match.url}/Login`} />
                            </Switch>
                        </div>

                    </GridItem>
                </GridContainer>
            </div >
        </>
    );
};

export default PublicPage;